<!-- ==================== TOP HEADER BAR ==================== -->
<div class="page-wrapper mb-3">
  <app-amplitude-chart
    [macId]="macId"
    [deviceInfo]="getActiveDeviceInfoWithMac()"
    [sensorCards]="sensorCards"
    [chartAlerts]="chartAlerts"
    (chartReady)="onChartReady()">
  </app-amplitude-chart>
  <!-- BREADCRUMB + ACTIVE BADGE ROW -->
  <div class="header-row">
    <div class="breadcrumbs">
      <span class="breadcrumb-chip">
        {{ selectedDevice?.floorName }}
      </span>
<!-- 
      <span class="breadcrumb-chip">
        {{ getActiveDeviceInfo().room }}
      </span>

      <span class="breadcrumb-chip breadcrumb-chip--active">
        {{ getActiveDeviceInfo().bed }}
      </span> -->
    </div>

    <div class="header-right">
      <span class="active-badge">Active</span>

      <div
        class="signal-bars"
        [attr.title]="wifiSignalLabel || 'WiFi signal'"
        [attr.aria-label]="wifiSignalLabel ? ('WiFi strength: ' + wifiSignalLabel) : 'WiFi signal'"
      >
        <span
          *ngFor="let i of signalBarIndexes"
          [class]="'bar bar--' + i + (i <= wifiSignalBars ? ' bar--active' : '')"
        ></span>
      </div>
    </div>
  </div>

  <!-- DEVICE TITLE -->
  <div class="device-title-block">
    <h1 class="device-title">
      Device {{ selectedDevice?.deviceName}}
    </h1>
    <p class="device-id">{{ macId }}</p>
   <!--  <p class="device-desc">{{ deviceDesc }}</p> -->
  </div>

  <!-- ==================== ALERTS ==================== -->
  <div
    class="alerts-section"
    [class.alerts-section--fullscreen]="isAlertsFullscreen"
  >

  <!-- HEADER -->
  <div class="alerts-header d-flex justify-content-between align-items-center mb-3">
    <h2 class="alerts-title mb-0">
      Unresolved alerts ({{ alertTotalRecords || alerts.length }})
    </h2>

    <div class="alerts-header-actions">
      <a
        href="#"
        class="view-all-alerts"
        *ngIf="!isAlertsFullscreen"
        (click)="viewAllAlerts($event)"
      >
        View all alerts
      </a>

      <button
        type="button"
        class="alerts-close-btn"
        *ngIf="isAlertsFullscreen"
        (click)="closeAlertsFullscreen()"
        title="Close fullscreen"
      >
        ✕ Close
      </button>
    </div>
  </div>

  <!-- TABLE -->
  <div class="alerts-table-wrap">
  <div
    class="alerts-table"
    #alertsTable
    [class.alerts-table--fullscreen]="isAlertsFullscreen"
    (scroll)="onAlertsScroll($event)"
  >
    <table class="table align-middle mb-0">

      <!-- TABLE HEAD -->
      <thead>
        <tr>
          <th scope="col" class="col-datetime">Date/Time</th>
          <th scope="col" class="col-alert">Alert</th>
          <th scope="col" class="col-floor">Floor</th>
          <th scope="col" class="col-status">Status</th>
          <th scope="col" class="col-action">Action</th>
        </tr>
      </thead>

      <!-- TABLE BODY -->
      <tbody>

        <!-- EMPTY STATE -->
        <tr *ngIf="alertsLoading && alerts.length === 0">
          <td colspan="5" class="text-center text-muted py-4">
            Loading alerts...
          </td>
        </tr>

        <tr *ngIf="!alertsLoading && alerts.length === 0">
          <td colspan="5" class="text-center text-muted py-4">
            No active alerts
          </td>
        </tr>

        <tr *ngFor="let alert of alerts; trackBy: trackByAlertId">

          <!-- DATE (API UTC → browser local) -->
          <td class="col-datetime">
            <span class="date-text">{{
              (getAlertDate(alert) | date: "dd/MM/yyyy HH:mm:ss") || "N/A"
            }}</span>
          </td>

          <!-- ALERT -->
          <td class="col-alert">
            <strong>{{ alert.type }}</strong>
          </td>

          <!-- FLOOR -->
          <td class="col-floor">
            {{ alert.floorName }}
          </td>

          <!-- STATUS -->
          <td class="col-status">
            <span
              class="status"
              [ngClass]="{
                'status--not-ack': alert.status === 'NotAcknowledged',
                'status--ack': alert.status === 'Acknowledged'
              }"
            >
              {{ alert.status }}
            </span>
          </td>

          <!-- ACTION -->
          <td class="col-action">
            <button
              *ngIf="alert.status === 'NotAcknowledged'"
              class="btn btn-primary btn-sm action-btn"
              (click)="acknowledgeAlert(alert)"
            >
              Acknowledge
            </button>

            <button
              *ngIf="alert.status === 'Acknowledged'"
              class="btn btn-success btn-sm action-btn"
              (click)="resolveAlert(alert)"
            >
              Resolve
            </button>
          </td>
        </tr>

        <tr *ngIf="alertsLoading && alerts.length > 0">
          <td colspan="5" class="text-center text-muted py-3">
            Loading more alerts...
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <button
    type="button"
    class="tap-top alerts-tap-top"
    *ngIf="showAlertsBackToTop"
    (click)="scrollAlertsToTop()"
    aria-label="Back to top"
    title="Back to top"
  >
    <app-feather-icon [icon]="'chevrons-up'"></app-feather-icon>
  </button>
  </div>
</div>

  <!-- ==================== DATA TRANSMISSION CHART ==================== -->
  <div class="chart-section">
    <div class="chart-header">
      <h2 class="chart-title">Data transmission</h2>
      <div class="d-flex align-items-center">
       <input 
        type="date"
        class="form-control rounded"
        (change)="onDateChange($event)"
        />
      </div>
    </div>

    <!-- CHART AREA -->
    <highcharts-chart
      [Highcharts]="Highcharts"
      [options]="chartOptions"
      style="width: 100%; height: 220px; display: block;">
    </highcharts-chart>

    <div style="font-size:12px;color:#888;margin-top:6px">
      Idle
    </div>
   
   
  </div>

</div>  